import { GradeLevel } from '../grade-level';
import { StatusEnum } from '../status';
import { ClassroomAssignmentDTO } from '@models/student-assignment';

export interface IStudentGradeUnitListItemDTO {
  unitId: number;
  unitNumber: number;
  unitTitle: string;
  unitDescription: string;
  unitGradeLevel: GradeLevel;
  unitCoverImageId: string;
  unitCoverImageUrl: string;
  assignmentStatus: StatusEnum;
  assignments: ClassroomAssignmentDTO[];
}

export class StudentGradeUnitListItemDTO
  implements IStudentGradeUnitListItemDTO
{
  unitId: number = null;
  unitNumber: number = null;
  unitTitle: string = '';
  unitDescription: string = '';
  unitGradeLevel: GradeLevel = null;
  unitCoverImageId: string = '';
  unitCoverImageUrl: string = '';
  assignmentStatus: StatusEnum = StatusEnum.NULL_STATUS;
  assignments: ClassroomAssignmentDTO[] = [];

  constructor(configOverride?: Partial<IStudentGradeUnitListItemDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
